const API = "https://suite24.emarsys.net/u/register.php";
const FAIL_MESSAGE = "Oops! Something went wrong, please refresh the page and try again.";
const PARAMS = {
  CID: 785825047,
  p: 2,
  a: "r",
  SID: "",
  el: "",
  llid: "",
  counted: "",
  c: "",
  optin: "y"
};
const SUCCESS_MESSAGE = "Thank you for signing up!";

export { API, FAIL_MESSAGE, PARAMS, SUCCESS_MESSAGE };



// WEBPACK FOOTER //
// ./const/Emarsys.js